import { action, makeObservable, observable } from 'mobx';

interface IExtensionOutput {
    entry: string;
    timestamp: Date;
}

interface IExtensionVersion {
    id: string;
    sha256: string;
}

interface IExtensionHostScan {
    id: string;
    ip: string;
}

interface IExtensionResult {
    id?: string;
    extensionId: string;
    extensionVersionId: string;
    output: { output: IExtensionOutput[] };
    extensionVersion: IExtensionVersion;
    version: string;
    startedOn: Date;
    endedOn: Date;
    hostname?: string;
    ip?: string;
    success: boolean | null;
    sha256?: string;
}

export default class ExtensionResultStore {
    extensionResult: IExtensionResult = {
        id: '',
        extensionId: '',
        extensionVersionId: '',
        output: { output: [] },
        version: '',
        startedOn: new Date(),
        endedOn: new Date(),
        success: null
    };

    constructor(extensionResult: IExtensionResult) {
        makeObservable(this, {
            extensionResult: observable,
            update: action
        });

        this.update(extensionResult);
    }

    update(extensionResult: IExtensionResult): void {
        const { extensionVersion: { sha256 } = {} } = extensionResult;
        this.extensionResult = {
            ...this.extensionResult,
            ...extensionResult,
            version: sha256 ? sha256.substring(0, 8) : ''
        };
    }
}
